export default __webpack_public_path__ + "static/Prevodnik-936960b498dd7ffff0d5082e8f511db9.svg";